<template>
    <v-list
      class="draggable-item small"
    >
      <v-list-tile>
        <v-list-tile-action style="min-width: 30px;">
          <v-checkbox
            :input-value="item.checked"
            @change="$emit('update:checked', $event)"
            :disabled="mode"
            hide-details
            class="ma-0 pa-0"
          />
        </v-list-tile-action>
        <v-list-tile-action style="min-width: 30px;">
          <v-icon>{{ item.hasOwnProperty('type') && item.type === "device" ? "smartphone" : "bluetooth"}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <v-layout
              align-center
              justify-space-between
              row
              style="width: 100%"
            >

              <strong style="white-space: nowrap; margin: 8px">{{ item.name }}</strong>
              <svg v-if="item.x > 0 && item.y > 0 || item.set" height="10" width="10">
                <circle cx="5" cy="5" r="5" fill="#00897b"></circle>
              </svg>
            </v-layout>
          </v-list-tile-title>
          <v-list-tile-sub-title
            v-if="item.shared_apps && user.client_id !== item.client_id"
          >
            <div>
              <span
                style="white-space: nowrap"
              >App: {{ `${item.shared_apps.filter(app => apps.includes(app.id)).slice(0, 2).map(app => app.name).join(', ')}${item.shared_apps.filter(app => apps.includes(app.id)).length > 2 ? '...' : ''}`}}</span>
            </div>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="item.shared && user.client_id !== item.client_id">
          <div>
            <span
              style="white-space: nowrap; color: blue; text-overflow: ellipsis;"
            >Shared</span>
          </div>
        </v-list-tile-action>
        <beacon-setting
          :selected="item"
          :key="item.uuid"
          :beaconsData="item"
          :onFilterBeacons="onFilterBeacons"
          :image="image"

          @onClose="onForceUpdate"
        ></beacon-setting>
        <device-setting
          :selected="item"
          :key="item.id"
          :beaconsData="item"
          :onFilterBeacons="onFilterBeacons"
          :image="image"
          @onClose="onForceUpdate"
        ></device-setting>
      </v-list-tile>
    </v-list>
</template>

<script>
import BeaconSetting from "./BeaconSetting";
import DeviceSetting from "./DeviceSetting";

export default {
  props: ["item", "user", "apps", "index", "items", "onFilterBeacons", "image", "mode"],
  components: {
    BeaconSetting,
    DeviceSetting
  },
  methods: {
    onForceUpdate() {
        // need to force update since the draggable item is not updated when x,y change.
        this.$forceUpdate();
    },
  },
};
</script>

<style>
</style>